// Cartolas subidas — listado de archivos cargados (Iter 358)
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Loader2, Eye, Trash2, FileSpreadsheet, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { fmtFecha } from '../../lib/utils';

const CLP = (v) => (v || 0).toLocaleString('es-CL');
const fmtFechaHora = (iso) => (iso ? `${fmtFecha(iso)} ${new Date(iso).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit', hour12: false })}` : '—');

const ESTADO_MATCH = {
  procesando: { cls: 'bg-sky-100 text-sky-700', label: 'Conciliando…', Icon: Loader2, spin: true },
  listo: { cls: 'bg-emerald-100 text-emerald-700', label: 'Listo', Icon: CheckCircle2 },
  interrumpido: { cls: 'bg-amber-100 text-amber-700', label: 'Interrumpido · usa Re-match', Icon: AlertTriangle },
  error: { cls: 'bg-red-100 text-red-700', label: 'Error en match', Icon: AlertTriangle },
};

export const CartolasTab = ({ cargas, onVer, onEliminar }) => (
  <Card>
    <CardContent className="p-0 overflow-x-auto">
      <table className="w-full text-sm" data-testid="tabla-cartolas">
        <thead>
          <tr className="border-b bg-slate-50 text-left text-xs text-muted-foreground">
            <th className="px-3 py-2">Archivo</th>
            <th className="px-3 py-2">Período</th>
            <th className="px-3 py-2">Cuenta</th>
            <th className="px-3 py-2 text-right">Movs</th>
            <th className="px-3 py-2 text-right">Nuevos</th>
            <th className="px-3 py-2 text-right">Duplicados</th>
            <th className="px-3 py-2 text-right">Auto</th>
            <th className="px-3 py-2 text-right">Cargos / Abonos</th>
            <th className="px-3 py-2">Subida</th>
            <th className="px-3 py-2">Match</th>
            <th className="px-3 py-2" />
          </tr>
        </thead>
        <tbody>
          {cargas.length === 0 && (
            <tr><td colSpan={11} className="px-3 py-8 text-center text-muted-foreground" data-testid="cartolas-empty">Aún no hay cartolas subidas</td></tr>
          )}
          {cargas.map((c) => {
            const em = ESTADO_MATCH[c.estado_match] || ESTADO_MATCH.listo;
            return (
              <tr key={c.id} className="border-b last:border-0 hover:bg-slate-50/50" data-testid={`cartola-row-${c.id}`}>
                <td className="max-w-[260px] truncate px-3 py-2 font-medium" title={c.nombre_archivo}>
                  <FileSpreadsheet className="mr-1 inline h-4 w-4 text-emerald-700" />{c.nombre_archivo}
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-xs">{fmtFecha(c.fecha_desde)} → {fmtFecha(c.fecha_hasta)}</td>
                <td className="whitespace-nowrap px-3 py-2 font-mono text-xs">{c.cuenta}</td>
                <td className="px-3 py-2 text-right font-mono text-xs">{c.total_movimientos}</td>
                <td className="px-3 py-2 text-right font-mono text-xs text-emerald-700">{c.nuevos}</td>
                <td className="px-3 py-2 text-right font-mono text-xs text-muted-foreground" title={c.duplicados_otro_formato ? `${c.duplicados_otro_formato} ya existían con otra glosa (otro informe del portal)` : ''}>
                  {c.duplicados}{c.duplicados_otro_formato ? ` (${c.duplicados_otro_formato}*)` : ''}
                </td>
                <td className="px-3 py-2 text-right font-mono text-xs">{c.auto_conciliados ?? 0}</td>
                <td className="whitespace-nowrap px-3 py-2 text-right font-mono text-xs">
                  <span className="text-red-600">${CLP(c.total_cargos)}</span> / <span className="text-emerald-600">${CLP(c.total_abonos)}</span>
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-xs">
                  <div>{fmtFechaHora(c.fecha_carga)}</div>
                  <div className="text-muted-foreground">{c.cargado_por}</div>
                </td>
                <td className="whitespace-nowrap px-3 py-2">
                  <Badge className={`${em.cls} hover:${em.cls} gap-1`} data-testid={`cartola-match-${c.id}`}>
                    <em.Icon className={`h-3 w-3 ${em.spin ? 'animate-spin' : ''}`} />
                    {em.label}{c.estado_match === 'procesando' ? ` ${c.match_revisados || 0}/${c.match_total || 0}` : ''}
                  </Badge>
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-right">
                  <Button variant="ghost" size="sm" className="text-blue-600" onClick={() => onVer(c.id)} data-testid={`btn-ver-cartola-${c.id}`}>
                    <Eye className="mr-1 h-3.5 w-3.5" /> Ver
                  </Button>
                  <Button variant="ghost" size="sm" className="text-red-600" onClick={() => onEliminar(c.id)} disabled={c.estado_match === 'procesando'} data-testid={`btn-eliminar-cartola-${c.id}`}>
                    <Trash2 className="h-3.5 w-3.5" />
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </CardContent>
  </Card>
);
